import { CommandButton, FooterMenu } from "components"
import { useToggle } from "utils"
import { AttachmentModal } from "./AttachmentModal"
import { Fragment } from "react"
import { Print } from "./Print"
import { PERMISION } from "security"

type CommandButtonsProps = {
  received?: boolean
  approvalView?: boolean
  showSaveButton?: boolean
  showDeleteButton?: boolean
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  received,
  approvalView,
  showSaveButton,
  showDeleteButton,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  const modalJournalInvoice = useToggle(false)

  return (
    <>
      {!approvalView && (
        <FooterMenu
          hasCancelButton
          customElement={{
            print: <Print/>,
            save: (
              <Fragment>
                {showSaveButton && (
                  <CommandButton
                    actiontype="save"
                    type="button"
                    color="primary"
                    permission={PERMISION.INVENTORY.TRANSACTION.CREATE_RECEIVED_ITEM.CREATE}
                    onClick={onSave}
                  />
                )}
              </Fragment>
            ),
            delete: (
              <Fragment>
                {showDeleteButton && (
                  <CommandButton actiontype="delete" onClick={onDelete} />
                )}
              </Fragment>
            ),
            journal: (
              <Fragment>
                {!received && (
                  <CommandButton
                    actiontype="journal"
                    onClick={modalJournalInvoice.toggle}
                  />
                )}
              </Fragment>
            ),
            attachment: <AttachmentModal />

          }}
        />
      )}
    </>
  )
}
